import React from "react";
import PopUp from "../PopUp";

const Cotizador = () => {
  return (
    <>
      <PopUp />
    </>
  );
};

export default Cotizador;
